export default {
  language: 'English',
  'language-short': 'EN',

  pagination: {
    previous: 'Previous',
    next: 'Next',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results'
  },

  components: {
    pagination: {
      previous: 'Previous',
      next: 'Next',
      showing: 'Showing',
      to: 'to',
      of: 'of',
      results: 'results'
    },
    formErrors: {
      required: 'This field is required',
      email: 'This field must be a valid email address',
      minLength: 'This field must be at least {min} characters long',
      maxLength: 'This field must not exceed {max} characters',
      numeric: 'This field must contain only numbers',
      sameAs: 'This field must match the {field} field',
      url: 'This field must be a valid URL'
    },
    alerts: {
      success: 'Success',
      info: 'Information',
      warning: 'Warning',
      error: 'Error'
    }
  },

  menu: {
    login: 'Login',
    signup: 'Sign up',
    logout: 'Logout',
    account: 'My account',
    dashboard: 'Dashboard',
    admin: 'Administration'
  },

  auth: {
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      forgot: 'Forgot password?',
      submit: 'Login',
      noAccount: 'Don\'t have an account?',
      signup: 'Sign up'
    },
    signup: {
      title: 'Sign up',
      firstname: 'First name',
      lastname: 'Last name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      submit: 'Sign up',
      hasAccount: 'Already have an account?',
      login: 'Login'
    },
    passwordReset: {
      title: 'Reset your password',
      email: 'Email',
      submit: 'Send reset link',
      back: 'Back to login'
    },
    passwordUpdate: {
      title: 'Update your password',
      password: 'New password',
      confirmPassword: 'Confirm new password',
      submit: 'Update password'
    }
  },

  dashboard: {
    nav: {
      overview: 'Overview',
      profile: 'Profile',
      settings: 'Settings'
    },
    welcome: 'Welcome {name}',
    stats: {
      title: 'Your stats',
      bookings: 'Bookings',
      favorites: 'Favorites',
      reviews: 'Reviews'
    }
  },

  profile: {
    title: 'My profile',
    personal: {
      title: 'Personal information',
      firstname: 'First name',
      lastname: 'Last name',
      email: 'Email',
      phone: 'Phone',
      save: 'Save changes'
    },
    password: {
      title: 'Change password',
      current: 'Current password',
      new: 'New password',
      confirm: 'Confirm new password',
      save: 'Update password'
    },
    notifications: {
      title: 'Notification preferences',
      email: 'Email notifications',
      push: 'Push notifications',
      sms: 'SMS notifications',
      save: 'Save preferences'
    }
  },

  admin: {
    nav: {
      dashboard: 'Dashboard',
      users: 'Users',
      facilities: 'Facilities',
      bookings: 'Bookings',
      settings: 'Settings'
    },
    users: {
      title: 'Users management',
      create: 'Add user',
      search: 'Search users',
      table: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        created: 'Created',
        actions: 'Actions'
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended'
      },
      edit: {
        title: 'Edit user',
        save: 'Save changes'
      }
    },
    facilities: {
      title: 'Facilities management',
      create: 'Add facility',
      search: 'Search facilities',
      table: {
        name: 'Name',
        type: 'Type',
        city: 'City',
        status: 'Status',
        created: 'Created',
        actions: 'Actions'
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending verification'
      },
      edit: {
        title: 'Edit facility',
        save: 'Save changes'
      }
    }
  },

  facility: {
    title: 'Facility',
    user: 'User',
    manager: 'Facility Manager',
    facilityManager: 'Facility Manager',
    nav: {
      dashboard: 'Dashboard',
      info: 'Information',
      contacts: 'Contacts',
      housing: 'Housing',
      features: 'Features',
      media: 'Media',
      documents: 'Brochures'
    },
    dashboard: {
      title: 'Facility dashboard',
      welcome: 'Welcome to your facility dashboard',
      totalLeads: 'Total leads',
      newLeads: 'New leads',
      reviews: 'Reviews',
      trafficStats: 'Traffic statistics',
      trafficStatsDescription: 'Overview of visits to your facility page',
      dateStart: 'Start date',
      dateEnd: 'End date',
      granularity: 'Granularity',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      noTrafficData: 'No data available for the selected period',
      visits: 'Visits',
      stats: {
        bookings: 'Bookings',
        views: 'Profile views',
        inquiries: 'Inquiries'
      }
    },
    info: {
      title: 'Facility information',
      title_description: 'Basic information about your facility',
      name: 'Name',
      description: 'Description',
      type: 'Type',
      group: 'Group',
      address: 'Address',
      streetName: 'Street name',
      streetNumber: 'Street number',
      zipCode: 'Zip code',
      city: 'City',
      country: 'Country',
      phone: 'Phone',
      website: 'Website',
      email: 'Email',
      socialMedia: 'Social media',
      facebook: 'Facebook',
      twitter: 'Twitter',
      instagram: 'Instagram',
      linkedin: 'LinkedIn',
      save: 'Save',
      cancel: 'Cancel',
      success: 'Facility information updated successfully',
      error: 'Error updating facility information',
      trafficStats: 'Traffic statistics',
      trafficStatsDescription: 'Overview of visits to your facility page',
      dateStart: 'Start date',
      dateEnd: 'End date',
      granularity: 'Granularity',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      noTrafficData: 'No data available for the selected period'
    },
    contacts: {
      title: 'Contacts',
      add: 'Add contact',
      edit: 'Edit contact',
      noContacts: 'No contacts added yet',
      form: {
        firstname: 'First name',
        lastname: 'Last name',
        role: 'Role',
        email: 'Email',
        phone: 'Phone',
        save: 'Save',
        cancel: 'Cancel'
      }
    },
    housing: {
      title: 'Housing units',
      add: 'Add housing unit',
      edit: 'Edit housing unit',
      noHousing: 'No housing units added yet',
      form: {
        name: 'Name',
        type: 'Type',
        capacity: 'Capacity',
        price: 'Price',
        pricePerDay: 'Price per day',
        priceConversionNote: 'Daily price × 30 = Monthly price',
        description: 'Description',
        features: 'Features',
        save: 'Save',
        cancel: 'Cancel',
        multiAdd: 'Add multiple types',
        selectTypes: 'Select types',
        typesSelected: 'type(s) selected',
        addAnother: 'Add another +'
      }
    },
    features: {
      title: 'Features',
      edit: 'Edit features',
      noFeatures: 'No features added yet',
      save: 'Save changes',
      cancel: 'Cancel'
    },
    media: {
      title: 'Media',
      noMedia: 'No media has been added',
      addMedia: 'Add media',
      mediaType: 'Type of media',
      altText: 'Alt text',
      altTextPlaceholder: 'Description of the media',
      file: 'File',
      uploadFile: 'Upload file',
      dragDrop: 'drag and drop',
      noAltText: 'No description',
      confirmDelete: 'Are you sure you want to delete this media?',
      mainMedia: 'Main media',
      setAsMain: 'Set as main media',
      delete: 'Delete'
    },
    documents: {
      title: 'Brochures',
      noDocuments: 'No brochures have been added',
      addDocument: 'Add brochure',
      name: 'Name',
      namePlaceholder: 'Brochure name',
      file: 'File',
      uploadFile: 'Upload file',
      dragDrop: 'drag and drop',
      viewDocument: 'View document',
      confirmDelete: 'Are you sure you want to delete this brochure?',
      delete: 'Delete'
    },
    leads: {
      title: 'Contact Requests',
      loading: 'Loading requests...',
      noLeads: 'No contact requests',
      markAsRead: 'Mark as read',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      date: 'Date',
      actions: 'Actions',
      view: 'View',
      details: 'Request details',
      back: 'Back',
      message: 'Message',
      budget: 'Budget',
      couple: 'Couple',
      delay: 'Timeframe',
      person1: 'Person 1',
      person2: 'Person 2',
      fullName: 'Full name',
      age: 'Age',
      autonomous: 'Autonomous',
      geoSearch: {
        city: 'Search city: {name} {code} within a radius of {radius} km',
        department: 'Search department: {name} {code}'
      }
    }
  },
  
  group: {
    title: 'Group Dashboard',
    groupUser: 'Group User',
    groupManager: 'Group Manager',
    nav: {
      dashboard: 'Dashboard',
      facilities: 'Facilities',
      reporting: 'Reporting',
      leads: 'Contact Requests'
    },
    dashboard: {
      facilities: 'Facilities',
      totalLeads: 'Total leads',
      newLeads: 'New leads',
      trafficStats: 'Traffic statistics',
      trafficStatsDescription: 'Overview of visits to your facility pages',
      dateStart: 'Start date',
      dateEnd: 'End date',
      granularity: 'Granularity',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      allFacilities: 'All facilities',
      noTrafficData: 'No data available for the selected period',
      visits: 'Visits',
      latestLeads: 'Latest contact requests',
      latestLeadsDescription: 'Last 100 contact requests received'
    },
    leads: {
      title: 'Contact Requests',
      loading: 'Loading requests...',
      noLeads: 'No contact requests',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      date: 'Date',
      facility: 'Facility',
      actions: 'Actions',
      view: 'View'
    }
  },
  
  errors: {
    404: {
      title: 'Page not found',
      message: 'The page you are looking for does not exist or has been moved.',
      back: 'Back to home'
    },
    500: {
      title: 'Server error',
      message: 'Something went wrong on our server. Please try again later.',
      back: 'Back to home'
    }
  },

  commercial: {
    title: 'Commercial Area',
    commercialManager: 'Commercial Manager',
    dashboard: {
      title: 'Commercial Dashboard',
      leadsToProcess: 'Leads to process (New)',
      totalLeads: 'Total Leads',
      processedLeads: 'Processed leads',
      actionsTitle: 'Calls & Tasks to do',
      overdue: 'Overdue',
      today: 'Today',
      future: 'Upcoming (next 10)',
      noActions: 'No calls or tasks scheduled.',
      taskLabel: 'Task',
      callLabel: 'Call'
    },
    leads: {
      title: 'Lead Management',
      searchPlaceholder: 'Search by name, email...',
      searchButton: 'OK',
      advancedFiltersButton: 'Advanced Filters',
      groupStatus: {
        toProcess: 'To Process',
        processed: 'Processed',
        closed: 'Closed',
        all: 'All'
      },
      filters: {
        status: 'Status',
        commercial: 'Sales Rep',
        source: 'Source',
        dateFrom: 'From',
        dateTo: 'To',
        allStatuses: 'All Statuses',
        allCommercials: 'All Sales Reps',
        allSources: 'All Sources'
      },
      table: {
        noLeadsFoundFilters: 'No leads found. Check your filters or reload the page.',
        noLeadsFoundSearch: 'No leads match the search criteria',
        headers: {
          name: 'Name',
          phone: 'Phone',
          email: 'Email',
          source: 'Source',
          status: 'Status',
          commercial: 'Sales Rep',
          date: 'Date',
          actions: 'Actions'
        }
      },
      actions: {
        viewDetailsTitle: 'View details',
        viewHistoryTitle: 'View history',
        assignCommercial: 'Assign'
      },
      pagination: {
        previous: 'Previous',
        next: 'Next',
        showingLeads: 'Showing {from} to {to} of {total} leads',
        previousSr: 'Previous',
        nextSr: 'Next'
      },
      historyModal: {
        title: 'Full History',
        closeSr: 'Close',
        noHistory: 'No history available',
        systemUser: 'System',
        typeCommercial: 'Sales Rep',
        typeStatus: 'Status'
      },
      errors: {
        loadFailed: 'Error loading leads: {message}',
        loadGeneric: 'An error occurred while loading leads',
        statusUpdateFailed: 'An error occurred while updating status',
        assignFailed: 'An error occurred while assigning the sales rep'
      },
      history: {
        commercialPrefix: 'Sales Rep: ',
        noCommercial: 'No sales rep'
      },
      lead: {
        notFound: 'Lead not found',
        facilityNoteTitle: 'Note for the facility',
        savingNote: 'Saving...',
        saveNote: 'Save note',
        errors: {
          statusUpdateFailed: 'Error updating status',
          saveFailed: 'An error occurred while saving'
        },
        parentOptions: [
          'Friend', 'Great grandchild', 'Other', 'Daughter-in-law', 'Sister-in-law',
          'Partner', 'Spouse', 'Cousin', 'Guardian (Curator)', 'Daughter', 'Son', 'Brother',
          'Son-in-law', 'Proxy', 'Doctor - organizations', 'General Practitioner', 'Mother',
          'Nephew', 'Niece', 'Notary', 'Uncle', 'Father', 'Person themselves', 'Myself',
          'Grandchild', 'Legal representative', 'Sister', 'Aunt', 'Guardian (Tutor)'
        ],
        admissionOptions: ['Immediate', '1 to 3 months', '3 to 6 months', '+ 6 months']
      }
    },
    map: {
      title: 'Facilities Map',
      backToDashboard: 'Back to Dashboard',
      searchFacilityPlaceholder: 'Search for a facility...',
      searchCityPlaceholder: 'Search for a city...',
      drawRadiusLabel: 'Draw a radius of',
      kmUnit: 'km',
      applyFilterButton: 'Apply',
      resetFilterButton: 'Reset',
      filterByPayingTitle: 'Filter by subscription:',
      payingAll: 'All',
      payingOnly: 'Paying',
      payingNone: 'Non-paying',
      filterByTypeTitle: 'Filter by type:',
      noTypesToFilter: 'No types to filter.',
      popup: {
        unknownName: 'Unknown name',
        groupLabel: 'Group: ',
        typesLabel: 'Type(s): '
      },
      errors: {
        selectCityFirst: 'Please select a city from the list before applying the filter.',
        mapInstanceUnavailable: 'Error: Map instance not available.',
        cannotDetermineCountry: 'Could not determine user\'s country.'
      }
    },
    facilities: {
      title: 'Facilities',
      searchPlaceholder: 'Search for a facility...',
      filterPaying: 'Filter by Paying Status',
      filterGroup: 'Filter by Group',
      filterType: 'Filter by Type',
      allGroups: 'All Groups',
      allTypes: 'All Types',
      payingStatus: {
        all: 'All',
        yes: 'Paying',
        no: 'Not Paying'
      },
      listTitle: 'List of Facilities',
      name: 'Name',
      location: 'Location',
      group: 'Group',
      types: 'Types',
      paying: 'Paying',
      actions: 'Actions',
      view: 'View',
      noFacilities: 'No facilities found matching the selected criteria.',
      pagination: {
        show: 'Show',
        showing: 'Showing {from} to {to} of {total} facilities',
        previous: 'Previous',
        next: 'Next',
        previousSr: 'Previous',
        nextSr: 'Next'
      }
    }
  },

  common: {
    remove: 'Remove'
  }
} 